<template>
  <v-card
    flat
    class="p-0 text--accent-1 text-center menu-card"
    :class="{ 'branded-menu-card': isBranded }"
    :style="cardStyle"
    style="text-decoration: none; border-radius: 25px"
    :to="blank ? '' : route"
    :target="blank ? '_blank' : ''"
    @click="$emit('clicked')"
    :href="blank ? route : ''"
  >
    <v-card-title class="text-center m-0 p-o">
      <v-spacer></v-spacer>
      <v-avatar
        v-if="isBranded"
        size="56"
        :style="brandIconAvatarStyle"
      >
        <v-icon large :style="brandIconColorStyle">{{ icon }}</v-icon>
      </v-avatar>
      <template v-else>
        <v-icon
          x-large
          class="font-weight-light"
          :color="$vuetify.theme.isDark ? 'white' : 'blue'"
          >{{ icon }}</v-icon
        ><sup
          ><v-icon
            v-if="blank"
            x-small
            :color="$vuetify.theme.isDark ? 'white' : 'blue'"
            >mdi-open-in-new</v-icon
          ></sup
        >
      </template>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <h4
        class="font-weight-light m-0"
        :class="titleClass"
        :style="titleStyle"
      >
        {{ title }}
      </h4>
      {{ desription }}
    </v-card-text>
  </v-card>
</template>

<script>
import {
  getBrandIconAvatarStyle,
  getBrandIconColorStyle,
  getBrandPrimaryButtonTextStyle,
  getBrandSidebarStyle,
  hasPartnerBrandColors,
} from "../../utils/brandColors";

export default {
  props: {
    blank: {
      default: false,
      type: Boolean,
    },
    brandable: {
      default: false,
      type: Boolean,
    },
    title: {
      default: "Select",
      type: String,
    },
    desription: {
      default: "",
      type: String,
    },
    icon: {
      default: "",
      type: String,
    },
    route: {
      default: "",
      type: String,
    },
  },
  name: "MenuCard",
  computed: {
    business() {
      return this.$store.state.user.user_infor.current_business;
    },
    isBranded() {
      return this.brandable && hasPartnerBrandColors(this.business);
    },
    cardStyle() {
      if (!this.isBranded) {
        return {};
      }

      return {
        ...getBrandSidebarStyle(this.business),
        border: "2px solid transparent",
      };
    },
    brandIconAvatarStyle() {
      return getBrandIconAvatarStyle(this.business);
    },
    brandIconColorStyle() {
      return getBrandIconColorStyle(this.business);
    },
    titleStyle() {
      return this.isBranded ? getBrandPrimaryButtonTextStyle(this.business) : {};
    },
    titleClass() {
      if (this.isBranded) {
        return "";
      }

      return this.$vuetify.theme.isDark ? "white--text" : "blue--text";
    },
  },
};
</script>

<style scoped>
.menu-card {
  transition: 0.3s ease-in-out !important;
  border: 2px solid transparent;
}

.menu-card:not(.branded-menu-card):hover {
  transform: scale(1.1);
  border: 2px solid #2196f3 !important;
}

.menu-card.branded-menu-card:hover {
  transform: scale(1.1);
  border: 2px solid var(--brand-primary) !important;
}
</style>
